import React from 'react';
import ProductRegistration from './ProductRegistration';

const QuoteProducts = () => {
  return <ProductRegistration fixedProductSubType="기타" />;
};

export default QuoteProducts;
